import { Col, Row } from 'antd';
import {
  DateInput,
  FormInputItem,
  NumberInput,
  TextAreaInput,
} from '../../../../components/common/FormItem/FormItems';
import {
  SelectAirline,
  SelectAirport,
  SelectVendors,
} from '../../../../components/common/FormItem/SelectCustomFeilds';
import FormListAddRemove from '../../../../common/utils/FormListAddRemove';
import { IInvoiceTourTicket } from '../../Types/InvoiceTourTypes';
import { useWatch } from 'antd/es/form/Form';

interface props {
  key: number;
  index: number;
  name: number;
  requiredField: boolean;
  add: (name: string) => void;
  remove: any;
  form: any;
  tourTicketData?: IInvoiceTourTicket[];
  invComClientInfo?: string;
  setInstanceVendorTicket: any;
}

const TicketDynamicForm = ({
  key,
  index,
  name,
  requiredField,
  add,
  remove,
  form,
  tourTicketData,
  invComClientInfo,
  setInstanceVendorTicket,
}: props) => {
  const ticket_is_deleted: 0 | 1 = useWatch(['tourTickets', index, 'ticket_is_deleted'], form);

  return (
    <Row
      gutter={[10, 0]}
      key={key}
      align='middle'
      style={
        ticket_is_deleted === 1
          ? {
              backgroundColor: '#FFC0CB',
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            }
          : { display: 'flex', alignItems: 'center', width: '100%' }
      }
    >
      <FormInputItem
        required={requiredField}
        name={[name, 'ticket_no']}
        label='Ticket No'
        size={3}
      />
      <FormInputItem name={[name, 'ticket_pnr']} label='PNR' size={3} />

      <SelectAirport
        mode='multiple'
        label='Route'
        name={[name, 'ticket_route']}
        fullNamePath={[name, 'ticket_route']}
        size={3}
        form={form}
      />

      <DateInput name={[name, 'ticket_journey_date']} label='Journey Date' size={3} />
      <DateInput name={[name, 'ticket_return_date']} label='Return Date' size={3} />

      <SelectAirline name={[name, 'ticket_airline_id']} label='Airline' size={3} />

      <NumberInput
        label='Cost Price'
        name={[name, 'ticket_cost_price']}
        size={3}
        required={requiredField}
        maxChar={14}
        minChar={0}
      />

      <SelectVendors
        label='Vendor'
        size={3}
        name={[name, 'ticket_comvendor_id']}
        required={requiredField}
        rules={[
          ({ getFieldValue }) => ({
            validator(_, value: string) {
              const invoiceClient = getFieldValue(['tickets', name, 'invoice_combclient_id']);
              if (invoiceClient && invoiceClient === value) {
                return Promise.reject("Client and vendor can't be same!");
              }
              if (invComClientInfo !== undefined && invComClientInfo === value) {
                return Promise.reject("Client and vendor can't be same!");
              }
              return Promise.resolve();
            },
          }),
        ]}
        setInstanceVendorSelect={setInstanceVendorTicket}
      />
      <TextAreaInput name={[name, 'ticket_description']} label='Description' row={2} size={6} />
      <Col md={1}>
        {/* <BillingIsDeleted name={[name, 'other_trans_is_deleted']} /> */}
        <FormListAddRemove
          add={add}
          index={index}
          name={name}
          remove={remove}
          form={form}
          dataLength={tourTicketData?.length}
          NamePath={['tourTickets', name, 'ticket_is_deleted']}
        />
      </Col>
    </Row>
  );
};

export default TicketDynamicForm;
